import {Component, computed, input} from '@angular/core';
import {NgClass} from '@angular/common';
import {Tooltip} from 'primeng/tooltip';
import {TranslocoPipe} from '@jsverse/transloco';
import {HrToolAiCapabilityLevel} from '@frontend/shared-api';
import {HR_TOOL_AI_CAPABILITY_LEVEL_TEXT_CLASS} from '../../constants/hr-tool-ai-capability.constants';

@Component({
  selector: 'app-ai-capability-level-label',
  imports: [NgClass, Tooltip, TranslocoPipe],
  templateUrl: './ai-capability-level-label.component.html',
})
export class AiCapabilityLevelLabelComponent {
  readonly level = input<HrToolAiCapabilityLevel | null>(null);
  readonly testId = input<string | null>(null);

  protected readonly textClass = computed(() => {
    const level = this.level();
    return level ? HR_TOOL_AI_CAPABILITY_LEVEL_TEXT_CLASS[level] : '';
  });
  protected readonly labelKey = computed(() => `hrTool.aiCapabilityLevel.${this.level()}.label`);
  protected readonly tooltipKey = computed(
    () => `hrTool.aiCapabilityLevel.${this.level()}.tooltip`,
  );
}
